import "can/view/stache/";
import "can/route/";
import "d3";
import "lodash";
import "moment";
import "moment-timezone";
import $ from "jquery";
import "bootstrap";
import "bootstrap-dialog";
import "bootstrap-daterangepicker";
import "bootstrap-select";
import "bootstrap-multiselect";
import "canvg-origin";
import "dom-to-image";
import "jquery-sortable";
import "js-cookie";
import "jspdf";
import "jspdf-autotable";
import "magnific-popup";
import "select2";
import "save-svg-as-png";
import "toastr";
import "tooltipster";
import "timepicki";
import "src/helpers/translations";
import "src/helpers/vt-namespace";
import AppState from "./app.vm";
import appModels from "./app.models";

(function ($) {
    "use strict";
    const URL = window.location;
    var accessToken = new URLSearchParams(URL.search).get('token');
    if (accessToken) {
        Cookies.remove("credentials", {
            path: "/",
            secure: true,
            sameSite: "None"
        });
        sessionStorage.setItem('authToken', accessToken);
    }

    can.ajax({
        url: "/version",
        type: "GET",
        dataType: "json"
    })
        .then(function (responseData) {

            // Set Header for X-Client-Identifier for all ajax request
            can.ajaxSetup({
                beforeSend: function (xhr) {
                    if (location.hash.split("/")[1] == 'push-data') {
                        return;
                    }

                    xhr.setRequestHeader(
                        "X-Client-Identifier",
                        `VT-Portal;${responseData.version}`
                    );

                    const authTokenFromSessionStorage = sessionStorage.getItem('authToken');
                    if (authTokenFromSessionStorage) {
                        xhr.setRequestHeader(
                            "Authorization",
                            `Bearer ${authTokenFromSessionStorage}`
                        );
                        if (location.href.includes('?')) {
                            history.pushState({}, null, location.href.split('?')[0]);
                        }
                    }
                },
                converters: {
                    "text json": function (response) {
                        return response === "" ? null : JSON.parse(response);
                    },
                }
            });

            const appState = new AppState();

            Vistracks.Scope.$el = {
                $body: $("body"),
                $main: $("#main")
            };
            Vistracks.Scope.$el
                .$body.on("click", "a[href='javascript://']", event => event.preventDefault());

            // Set-up the routes rule
            can.route(":page", {
                page: "hos"
            });
            can.route(":page/:slug", {
                slug: null
            });
            can.route(":page/:slug/:id", {
                slug: null,
                id: null
            });
            can.route(":page/:slug/:id/:date", {
                slug: null,
                id: null,
                date: null
            });

            // Cache the application state
            Vistracks.Scope.AppState = appState;

            // Enable default theme
            Vistracks.Scope.$el
                .$body.addClass(Vistracks.Scope.AppState.attr("themeColor"));

            // Initialize application models which GETting the following APIs:
            // MyUser, MyAccount, Permissions, Products, VisibilitySets and AccountProperties.
            appModels(appState);
        });

    // Toastr notification settings
    toastr.options = {
        hideDuration: 100
    };
}($, moment));
